export default class GM_Helper {
    static init() {
        window.GM_Helper = GM_Helper;
    }
    /**
     * Custom smooth scroll with cubic-bezier easing
     * @param {HTMLElement|number} target - Element or scroll position (top)
     * @param {number} duration - Scroll duration in ms
     * @param {function} onComplete - Optional callback when scroll completes
     */
    static smoothScrollTo(target, duration = 1200, onComplete = null) {
        const startPosition = window.pageYOffset;
        let targetPosition;

        if (target instanceof HTMLElement) {
            targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
        } else {
            targetPosition = target;
        }

        const distance = targetPosition - startPosition;
        let startTime = null;
        let isCancelled = false;

        // Detect user interaction to cancel scroll
        const cancelScroll = () => {
            isCancelled = true;
            cleanup();
        };

        const cleanup = () => {
            window.removeEventListener('wheel', cancelScroll);
            window.removeEventListener('touchstart', cancelScroll);
            window.removeEventListener('mousedown', cancelScroll);
        };

        window.addEventListener('wheel', cancelScroll, { passive: true });
        window.addEventListener('touchstart', cancelScroll, { passive: true });
        window.addEventListener('mousedown', cancelScroll, { passive: true });

        function ease(t) {
            // Custom EaseInOutQuint for gradual acceleration and deceleration
            return t < 0.5 ? 16 * Math.pow(t, 5) : 1 - Math.pow(-2 * t + 2, 5) / 2;
        }

        function animation(currentTime) {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);

            if (!isCancelled) {
                window.scrollTo(0, startPosition + distance * ease(progress));
            }

            if (progress < 1 && !isCancelled) {
                requestAnimationFrame(animation);
            } else {
                cleanup();
                if (onComplete && typeof onComplete === 'function') {
                    onComplete(!isCancelled);
                }
            }
        }

        requestAnimationFrame(animation);
    }

    /**
     * Check for honeypot field value to detect spam bots
     * @param {jQuery} $form - jQuery form object
     * @returns {boolean} - True if legitimate, false if spam detected
     */
    static checkHoneypot($form) {
        const honeypotValue = $form.find('#med').val() ?? '';

        if (honeypotValue !== '') {
            window.location.replace("about:blank");
            setTimeout(() => {
                history.pushState(null, null, 'about:blank');
                history.pushState(null, null, 'about:blank');
                history.go(-2);
            }, 0);
            return false; // Spam detected
        }

        return true; // Legitimate submission
    }

    /**
     * Get the loader HTML.
     * @param {string} className - Additional classes for the loader
     * @returns {string} - Loader HTML string
     */
    static getLoader(className = '') {
        const fullClass = `loader ${className}`.trim();
        return `<div class="${fullClass}" aria-hidden="true">
            <div></div>
            <div></div>
        </div>`;
    }
}
